import {
  Button,
  Card,
  Col,
  Collapse,
  Form,
  InputNumber,
  Modal,
  Radio,
  Row,
  Tooltip,
} from "antd";
import TextArea from "antd/lib/input/TextArea";
import { useContext, useEffect, useState } from "react";
import { SignedInContext } from "../AppEnv";
import { SignedInDoctor } from "../auth/interfaces";
import { getDoctorData } from "../doctor/utils";
import { Patient, StrongHandType } from "../patients/interfaces";
import { editPatient } from "../patients/utils";
import {
  EXAM_PODO_STIM_SLUGNAME,
  pexamTypeToFullname,
} from "./exams_definitions_utils";
import { PosturalExamination } from "./interfaces";
import { editPosturalExamination } from "./utils";
import { RocketOutlined } from "@ant-design/icons";
import "./Exam.css";
import DeliveryButton from "../buttons/DeliveryButton";
import emailjs from "emailjs-com";
import { Studio, emptyStudio } from "../studio/interfaces";
import { getStudio } from "../studio/utils";

const { Panel } = Collapse;

//OTHER TRY
/*
const fetchData = async (input: string) => {
  const response = await axios.post(
    "https://www.api.openai.com/v1/completions",
    {
      prompt: `Crea un report finale con un massimo di 250 parole con queste caratteristiche: "${input}"`,
      model: "text-davinci-003",
      max_tokens: 200,
      n: 1,
      stop: ".",
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${process.env.OPENAI_API_KEY}`,
      },
    }
  );

  return response.data.choices[0].text;
};
*/
//START API REQUEST OPENAI
/*
const configuration = new Configuration({
  apiKey: process.env.OPENAI_API_KEY,
});
const openai = new OpenAIApi(configuration);

const completion = openai.createCompletion({
  model: "text-davinci-003",
  prompt:
    "Crea un report finale con un massimo di 250 parole con queste caratteristiche linea bipupillare appare più alta, inclinazione del capo appare correttamente allineato" +
    {},
});
console.log(completion); */

//END OF APIREQUEST OPENAI

// URL del backend NestJS (proxy per OpenAI)
const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:3333';

const PosturalExamSummary = ({
  patient,
  posturalExamination,
  setPosturalExamination,
  setPatient,
}: {
  patient: Patient;

  posturalExamination: PosturalExamination;
  setPosturalExamination: Function;
  setPatient: Function;
}) => {
  console.log("summary");
  const signedInDoctor: SignedInDoctor =
    useContext(SignedInContext).signedInDoctor;
  const [doctorWhoPerformedTheExam, setDoctorWhoPerformedTheExam] = 
    useState<string>(
      signedInDoctor.id == posturalExamination.doctorId
        ? signedInDoctor.name + " " + signedInDoctor.surname
        : ""
    );

  const [additionalNotes, setAdditionalNotes] = useState(
    posturalExamination.additionalNote || ""
  );

  const [isChange, setIsChange] = useState(true);
 
  const [VisibleErrore, setVisibleErrore] = useState(false);

  //ERRORE Message

  const Errores = (
    <>
      <Row className="center-price">
        <div className="error center">
          <div className="error__icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              viewBox="0 0 24 24"
              height="24"
              fill="none"
            >
              <path
                fill="#393a37"
                d="m13 13h-2v-6h2zm0 4h-2v-2h2zm-1-15c-1.3132 0-2.61358.25866-3.82683.7612-1.21326.50255-2.31565 1.23915-3.24424 2.16773-1.87536 1.87537-2.92893 4.41891-2.92893 7.07107 0 2.6522 1.05357 5.1957 2.92893 7.0711.92859.9286 2.03098 1.6651 3.24424 2.1677 1.21325.5025 2.51363.7612 3.82683.7612 2.6522 0 5.1957-1.0536 7.0711-2.9289 1.8753-1.8754 2.9289-4.4189 2.9289-7.0711 0-1.3132-.2587-2.61358-.7612-3.82683-.5026-1.21326-1.2391-2.31565-2.1677-3.24424-.9286-.92858-2.031-1.66518-3.2443-2.16773-1.2132-.50254-2.5136-.7612-3.8268-.7612z"
              ></path>
            </svg>
          </div>
          <div className="error__title">
            ATTENZIONE! Ordine NON inviato, riprova.
          </div>
          <div className="error__close" onClick={() => setVisibleErrore(false)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              viewBox="0 0 20 20"
              height="20"
            >
              <path
                fill="#393a37"
                d="m15.8333 5.34166-1.175-1.175-4.6583 4.65834-4.65833-4.65834-1.175 1.175 4.65833 4.65834-4.65833 4.6583 1.175 1.175 4.65833-4.6583 4.6583 4.6583 1.175-1.175-4.6583-4.6583z"
              ></path>
            </svg>
          </div>
        </div>
      </Row>

      <Row className="spaceup"></Row>
    </>
  );

  //END ERRORE Message

  //Email stuff
  const [studio, setStudio] = useState(emptyStudio);

  useEffect(() => {
    getStudio(signedInDoctor)
      .then((fetchedStudio: Studio) => {
        setStudio({
          ...fetchedStudio,
        });
      })
      .catch((err) => console.error(err));
  }, [signedInDoctor]);

  const handleDeliveryButtonClick = async () => {
    // Qui inserisci la logica per la consegna, se necessario
    console.log("Email function CALLED!");
    // Immagine in base64 (sostituiscila con la tua immagine)

    const doc = signedInDoctor.name + " " + signedInDoctor.surname;
    const studi = studio.fullName;
    const email = signedInDoctor.email;
    const imageData = "https://www.google.com";

    console.log(doc + "  e " + email + " poi " + studi);
    // Invia l'email
    try {
      let text = "";
      if (!posturalExamination.testSelections) return;
      else {
        for (let test of posturalExamination.testSelections) {
          text += test.note ? test.note : "";
        }
      }
      const patientNames = patient.name + " " + patient.surname;
      const sizes = patient.footSize;

      console.log(patientNames);

      const response = await emailjs.send(
        "service_xfymk8k",
        "template_fi4ndje",
        {
          from_name: doctorWhoPerformedTheExam,
          software: "Physiocheck App®",
          doctor: doc,
          patient: patientNames,
          size: sizes,
          studio: studi,
          mail: email,
          message: text,
          image: imageData, // Includi l'immagine come parte del corpo del messaggio
        },
        "rpiDnE4Y8KRnxLT8F"
      );

      console.log("Email inviata con successo:", response);
    } catch (error) {
      setVisibleErrore(true);
      console.error("Errore nell'invio dell'email:", error);
    }
  };

  //Email Stuff End

  function call() {
    console.log("Ok");
    setIsChange(false);
    callOpenAIAPI();
  }

  let promptSintaxt1 = `Agisci come un terapista specializzato in posturologia.
Valuta la postura del paziente basandoti sulle osservazioni raccolte e descrivi, senza limitarti a riscrivere i dati raccolti, ma trasformandoli in una relazione professionale e sintetica:

Le caratteristiche della postura nei principali piani di analisi (frontale, sagittale e trasverso), includendo dettagli sulla simmetria, allineamento e rotazioni.
L’equilibrio globale del corpo, analizzando eventuali disallineamenti o deviazioni rispetto ai criteri di normalità.
Le anomalie posturali riscontrate, specificando le aree coinvolte e il loro impatto sulla distribuzione dei carichi corporei.
Una sintesi della valutazione che possa essere utilizzata come referto professionale, descrivendo in modo chiaro e medico-specialistico i punti critici rilevati durante l’analisi.
Scrivi tutto in forma di un unico testo fluido, completo e professionale, utilizzando un linguaggio tecnico ma comprensibile per il paziente. Non includere indicazioni terapeutiche o suggerimenti di trattamento.`;
  

  async function callOpenAIAPI() {
    let text = "";
    let examType = posturalExamination.type;
    if (!posturalExamination.testSelections) return;
    else {
      for (let test of posturalExamination.testSelections) {
        text += test.note ? test.note : "";
      }
    }
    const APIBody = {
      model: "gpt-3.5-turbo-instruct",
      prompt: 
      promptSintaxt1 + "Ti fornisco ora i dati: " + " " +
        text , 
      temperature: 0,
      max_tokens: 800,
      top_p: 1.0,
      frequency_penalty: 0.0,
      presence_penalty: 0.0,
    };

    console.log("esame di tipo: " + examType);
    console.log(
      promptSintaxt1 + "Ti fornisco ora i dati: " + "Tipo di Esame: " +  examType + " " +
        text , 
    );




    

    try {
      const response = await fetch(`${API_BASE}/openai/completion`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          prompt: promptSintaxt1 + "Ti fornisco ora i dati: " + " " + text,
          maxTokens: 800,
          temperature: 0,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      if (data.error) {
        throw new Error(data.error);
      }
      setAdditionalNotes(data.text); // Risposta dal backend
    } catch (error) {
      console.error("Error during API call:", error);

      // Gestisci l'errore in base alle tue esigenze
    }

    setIsChange(true);
  }

  useEffect(() => {
    if (true || signedInDoctor.id != posturalExamination.doctorId) {
      getDoctorData(signedInDoctor, posturalExamination.doctorId)
        .then((res) =>
          setDoctorWhoPerformedTheExam(res.name + " " + res.surname)
        )
        .catch((err) => setDoctorWhoPerformedTheExam(""));
    }
  }, []);
  const [biometricBaseVisible, setBiometricBaseVisible] =
    useState<boolean>(false);

  const updateBaseBiometric = (key: string, value: number) => {
    let updPosturalExamination = { ...posturalExamination, [key]: value };
    setPosturalExamination(updPosturalExamination);
    editPosturalExamination(signedInDoctor, patient, updPosturalExamination);
    if (posturalExamination.date) {
      let peDate = new Date(posturalExamination.date);
      if (
        peDate.getDay() == new Date().getDay() &&
        peDate.getMonth() == new Date().getMonth() &&
        peDate.getFullYear() == new Date().getFullYear()
      ) {
        let updPatient = { ...patient, [key]: value };
        setPatient(updPatient); //if date corresponds upd info of patient
        editPatient(signedInDoctor, updPatient);
      }
    }
  };

  const [stimos, setStimos] = useState(false);
  useEffect(() => {
    function stimo(examType: string) {
      return examType == EXAM_PODO_STIM_SLUGNAME;
    }

    setStimos(stimo(posturalExamination.type));
  });

  const updateAdditionalNotes = (notes: string) => {
    let updPosturalExamination = {
      ...posturalExamination,
      ["additionalNote"]: notes,
    };
    setPosturalExamination(updPosturalExamination);
    editPosturalExamination(signedInDoctor, patient, updPosturalExamination);
  };

  const numTestMade = posturalExamination.testSelections
    ? posturalExamination.testSelections.filter(
        (pe) => pe.selectedValue >= 0 && pe.passedValue != -2
      ).length
    : 0;
  const numTestPassed = posturalExamination.testSelections
    ? posturalExamination.testSelections.filter(
        (pe) => pe.selectedValue == pe.passedValue
      ).length
    : 0;
  const pendingTests = posturalExamination.testSelections
    ? posturalExamination.testSelections.filter((pe) => pe.passedValue != -2)
        .length - numTestMade
    : 0;
  return (
    <>
      <Card
        className="cardas"
        title={pexamTypeToFullname(posturalExamination.type)}
        extra={
          doctorWhoPerformedTheExam.length > 0
            ? "Esame effettuato da " + doctorWhoPerformedTheExam
            : ""
        }
      >
        <Row>
          <h4></h4>
        </Row>
        <Row>
          <h3>
            {numTestPassed > 0 ||
              numTestMade > 0 ||
              (pendingTests > 0 && (
                <>
                  Risultato:
                  <span style={{ fontWeight: "bold" }}>
                    {numTestPassed + " su " + numTestMade}
                  </span>{" "}
                  test passati
                  {pendingTests > 0 && (
                    <>
                      {" "}
                      <span
                        style={{
                          background: "#ffd969",
                          paddingLeft: "2px",
                          paddingRight: "2px",
                          fontWeight: "bold",
                          borderRadius: "4px",
                        }}
                      >
                        {pendingTests} test mancanti
                      </span>{" "}
                    </>
                  )}
                </>
              ))}
          </h3>
        </Row>

        <Collapse className="collap1">
          {posturalExamination.testSelections?.map((testSelection, index) => (
            <Panel
              className="panel1"
              header={testSelection.prefixNote}
              key={"ts_" + index}
              style={{
                fontWeight: "bold",
                background:
                  testSelection.passedValue != -2
                    ? testSelection.selectedValue < 0
                      ? "#ffd969"
                      : testSelection.selectedValue == testSelection.passedValue
                      ? "#60ee70"
                      : "#ee6060"
                    : "white",
              }}
            >
              <p style={{ fontWeight: "normal" }}>
                {testSelection.note &&
                  ((testSelection.note.indexOf(": ") > 0 &&
                    testSelection.note.substring(
                      testSelection.note.indexOf(": ") + 2
                    )) ||
                    testSelection.note)}
              </p>
            </Panel>
          ))}
        </Collapse>
        <div style={{ textAlign: "right", marginTop: "16px" }}>
          <Button type="primary" onClick={() => setBiometricBaseVisible(true)}>
            Biometriche base
          </Button>
        </div>
      </Card>

      <Card className="cardas2">
        <Row className="cent">
          <Col span={18}>
            <h5>Note aggiuntive</h5>
            <TextArea
              showCount
              defaultValue={posturalExamination.additionalNote}
              maxLength={4096}
              style={{ height: 120 }}
              onChange={(e) => {
                updateAdditionalNotes(e.target.value);
                setAdditionalNotes(e.target.value);
              }}
              value={additionalNotes}
              count={undefined}
            />
          </Col>
          <Col span={4} className="cent1">
            <div className="cent">
              <Tooltip title="Genera Testo Con AI" className="too1">
                <button
                  className={isChange ? "btnai" : "btnai-ok"}
                  onClick={() => call()}
                >
                  <div className="loader"></div>
                  <RocketOutlined
                    className={isChange ? "rock" : "rock-ok"}
                    rev={undefined}
                  />
                  <div id="container-stars">
                    <div id="stars"></div>
                  </div>
                  <div id="glow">
                    <div className="circle"></div>
                    <div className="circle"></div>
                  </div>
                </button>
              </Tooltip>
            </div>
          </Col>

          <Col span={24} style={{ display: "none" }}>
            <div className="spacez"></div>
            {VisibleErrore && Errores}
            <Col onClick={handleDeliveryButtonClick}>
              {stimos && <DeliveryButton />}
            </Col>
          </Col>
        </Row>
      </Card>
      <Modal
        title="Dati biometrici base"
        centered
        open={biometricBaseVisible}
        footer={false}
        onOk={() => setBiometricBaseVisible(false)}
        onCancel={() => setBiometricBaseVisible(false)}
        width={600}
      >
        <Form
          initialValues={{
            height: posturalExamination.height,
            weight: posturalExamination.weight,
            footSize: posturalExamination.footSize,
            strongHand: posturalExamination.strongHand,
          }}
        >
          <Row>
            <Col span={8}>
              <Form.Item name="height" label="Altezza (cm)">
                <InputNumber
                  min={0}
                  max={250}
                  step={0.5}
                  onChange={(value: number | null) => {
                    if (value !== null) {
                      updateBaseBiometric("height", value);
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="weight" label="Peso (kg)">
                <InputNumber
                  min={0}
                  max={450}
                  step={0.5}
                  onChange={(value: number | null) => {
                    if (value !== null) {
                      updateBaseBiometric("height", value);
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="footSize" label="Piede (EU)">
                <InputNumber
                  min={32}
                  max={50}
                  step={0.5}
                  onChange={(value: number | null) => {
                    if (value !== null) {
                      updateBaseBiometric("height", value);
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item name="strongHand" label="Mano Forte">
                <Radio.Group
                  onChange={(e) =>
                    updateBaseBiometric("strongHand", e.target.value)
                  }
                >
                  <Radio.Button value={StrongHandType.SX}>Sx</Radio.Button>
                  <Radio.Button value={StrongHandType.SX_DX}>
                    Ambidestro
                  </Radio.Button>
                  <Radio.Button checked value={StrongHandType.DX}>
                    Destro
                  </Radio.Button>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default PosturalExamSummary;
function setIsLoading(arg0: boolean) {
  throw new Error("Function not implemented.");
}
